import { Label, LabelColor } from '@shared/components';

export type ExamEventRegistrationStatusLabelVariants =
  | 'open-for-registration'
  | 'registration-closed'
  | 'session-full'
  | 'canceled'
  | 'temporarily-closed'
  | 'scheduled';

export const EXAM_EVENT_REGISTRATION_STATUS_COLOR: Readonly<
  Record<ExamEventRegistrationStatusLabelVariants, LabelColor>
> = {
  'open-for-registration': LabelColor.SUCCESS,
  'session-full': LabelColor.ERROR,
  'registration-closed': LabelColor.GREY,
  canceled: LabelColor.ERROR,
  'temporarily-closed': LabelColor.WARNING,
  scheduled: LabelColor.INFO,
};

export const EXAM_EVENT_REGISTRATION_STATUS_TEXT: Readonly<
  Record<ExamEventRegistrationStatusLabelVariants, string>
> = {
  'open-for-registration': 'เปิดรับสมัคร',
  'session-full': 'รอบสอบเต็ม',
  'registration-closed': 'ปิดรับสมัคร',
  'temporarily-closed': 'ปิดรับสมัครชั่วคราว',
  canceled: 'ยกเลิกรอบสอบ',
  scheduled: 'รอเปิดรับสมัคร',
};

interface ExamEventRegistrationStatusLabelProps {
  variant: ExamEventRegistrationStatusLabelVariants;
}

// TODO: Moved to Exam Event Management
export default function ExamEventRegistrationStatusLabel(
  props: Readonly<ExamEventRegistrationStatusLabelProps>,
) {
  const { variant } = props;

  return (
    <Label
      color={EXAM_EVENT_REGISTRATION_STATUS_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {EXAM_EVENT_REGISTRATION_STATUS_TEXT[variant]}
    </Label>
  );
}
